import './IgongMissionOrderResult.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import HongButton from '../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import HongAudioPlayer from '../audio/HongAudioPlayer';


const IgongMissionOrderResult = ({isJinroValue, studyJisu, gradeCode}) => {
    const S3_URL = process.env.REACT_APP_S3_URL_LOCAL;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [list, setList] = useState([]);
    const [audioSrc, setAudioSrc] = useState('');
    const [isAutoPlay, setIsAutoPlay] = useState(false);

  
    useEffect(() => {

        // console.log({isJinroValue, studyJisu, gradeCode},'{isJinroValue, studyJisu, gradeCode}');
        let gradeName = '';
        let score = '';
        let title = '';
        //고3은 안 나옴 (code 12)
        // alert(studyJisu + '스터디 지수')
        // alert(gradeCode)

        if (isJinroValue >= 100) {
            title = '진로확정';
        } else if (isJinroValue >= 60) {
            title = '진로모호';
        } else {
            title = '진로미확정';
        }

        if (studyJisu >= 80) {
            score = '80이상';
        } else if (studyJisu >= 60) {
            score = '60이상';
        } else if (studyJisu >= 40) {
            score = '40이상';
        } else {
            score = '40미만';
        }

     
        if (gradeCode >= 4 && gradeCode <= 8) {
            gradeName = '초4~중2';
        } else if (gradeCode >= 9 && gradeCode <= 11) {
            gradeName = '중3~고2';
        } else {
            gradeName = '';
        }

        fncSelect_list_missionOredrResult(title, score, gradeName);
    }, [studyJisu]);



    function fncSelect_list_missionOredrResult(title, score, gradeName) {
        fnc.sendAxios('/igongAssess_chart/select/assess_finalMissionOrderResult', {title, score, gradeName}, (res) => {
            if (res && Array.isArray(res)) {
                const newList = getRecords(res);
                setList(newList);
                const mp3FileName = res[0].mp3FileName;
                fncPlayMp3(mp3FileName);
            } else {
            alert('검색에 실패했습니다(donggi)');
            }
        });     
        
          function getRecords(res) {
            const records = [];
            res.forEach(item => {
            const sno = item["no"];
            const title = item["title"];
            const content = item["content"];
            const mp3FileName = item["mp3FileName"];
            records.push({ sno, title, content, mp3FileName });
            });
            return records;
        }
    }              


  
    async function fncPlayMp3(mp3FileName) {

        if (mp3FileName) {    
        // mp3FileName = 'cho_moho_40_down.mp3';
        const fullPath = await fncS4.getS3PathLong( `mp3/missionOrder/${mp3FileName}`);
        // console.log(fullPath, ' fullPath');
        // const fullPath = `https://autogen-igong.s3.ap-northeast-2.amazonaws.com/mp3/missionOrder/cho_ok_40_down.mp3`;
        // const fullPath = `${S3_URL}/mp3/missionOrder/${mp3FileName}`;
        setAudioSrc(fullPath);
        setIsAutoPlay(false); // 처음 시작할 때 자동재생을 false로 유지 (소리 안나오게)
        }   
    } 


    function onClickPlay() {
        const mp3FileName = list[0].mp3FileName;
        alert(mp3FileName)
        fncPlayMp3(mp3FileName);
    }

//=========================================
return (
    <div className='IgongMissionOrderResult'>
        <div className='title'>Final Mission Order</div>
        <section className='sec-main'>
            {/* <div className='mission-title'>{list[0]?.title}</div> */}
            <div className='mission-content'>{list[0]?.content}</div>
{/* {studyJisu} 최종값이 반영되는 지 확인요*/}
{/* 검증용 지수 */}
<div>
{studyJisu} 개발자 검수용
</div>

             <div className='box-menu'>
                <HongAudioPlayer 
                    audioSrc={audioSrc} 
                    autoPlay={isAutoPlay} 
                    onPlayCallback={() => console.log("Dynamic audio played")} 
                />
                {/* <HongButton className='h-btn-black' onClick={onClickPlay}>재생</HongButton> */}
            </div>


        </section>


    </div>
);
};

export default IgongMissionOrderResult;